"use strict";
/* eslint-disable camelcase */
/** Bank Institution */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestRateBenchmark = exports.InterestRateBenchmarkIterable = exports.AccountTypeSchema = exports.CapitalProviderAccountType = exports.CapitalProviderAccountTypeIterable = exports.BorrowerAccountType = exports.BorrowerAccountTypeIterable = exports.CurrencyCodeSchema = exports.CurrencyCodes = exports.Currency = exports.CurrencyIterable = exports.CashBalanceTypeSchema = void 0;
const zod_1 = require("zod");
/** Bank Account */
exports.CashBalanceTypeSchema = zod_1.z.enum(['available', 'current']);
// use CurrencyCode (below) instead
exports.CurrencyIterable = ['USD', 'CAD', 'MXN', 'EUR', 'GBP'];
exports.Currency = {
    USD: 'USD',
    CAD: 'CAD',
    MXN: 'MXN',
    EUR: 'EUR',
    GBP: 'GBP',
};
exports.CurrencyCodes = exports.CurrencyIterable;
exports.CurrencyCodeSchema = zod_1.z.enum(exports.CurrencyCodes);
exports.BorrowerAccountTypeIterable = [
    'collections',
    'otherReserveAccount',
    'parentOperatingAccount',
    'preFundingAccount',
    'permittedInvestmentsAccount',
    // TODO(jon): we should deprecate fixed account types. Bank accounts don't need to have a specific
    //  type; we just need to be able to customize their properties/behaviors.
    'accountIncludedInBorrowingBase',
];
exports.BorrowerAccountType = {
    Collections: 'collections',
    OtherReserveAccount: 'otherReserveAccount',
    ParentOperatingAccount: 'parentOperatingAccount',
    PreFundingAccount: 'preFundingAccount',
    PermittedInvestmentsAccount: 'permittedInvestmentsAccount',
    // TODO(jon): we should deprecate fixed account types. Bank accounts don't need to have a specific
    //  type; we just need to be able to customize their properties/behaviors.
    AccountIncludedInBorrowingBase: 'accountIncludedInBorrowingBase',
};
exports.CapitalProviderAccountTypeIterable = [
    'capitalProviderFundingAccount',
];
exports.CapitalProviderAccountType = {
    CapitalProviderFundingAccount: 'capitalProviderFundingAccount',
};
exports.AccountTypeSchema = zod_1.z.union([
    zod_1.z.enum(exports.BorrowerAccountTypeIterable),
    zod_1.z.enum(exports.CapitalProviderAccountTypeIterable),
]);
exports.InterestRateBenchmarkIterable = [
    'SOFR',
    'SOFR30DAvg',
    'SOFR90DAvg',
    'SOFRTerm1M',
    'SOFRTerm3M',
    'SOFRTerm6M',
    'LIBOR1M',
    'LIBOR3M',
    'EURIBOR1M',
    'EURIBOR3M',
    'CDOR1M',
    'CDOR3M',
    'PRIME',
    'TIIE30DAvg',
    'CMT3Y',
    'CMT5Y',
    'CMT7Y',
    'CMT10Y',
    'SONIA',
];
exports.InterestRateBenchmark = {
    SOFR: 'SOFR',
    SOFR30DAvg: 'SOFR30DAvg',
    SOFR90DAvg: 'SOFR90DAvg',
    SOFRTerm1M: 'SOFRTerm1M',
    SOFRTerm3M: 'SOFRTerm3M',
    SOFRTerm6M: 'SOFRTerm6M',
    LIBOR1M: 'LIBOR1M',
    LIBOR3M: 'LIBOR3M',
    EURIBOR1M: 'EURIBOR1M',
    EURIBOR3M: 'EURIBOR3M',
    CDOR1M: 'CDOR1M',
    CDOR3M: 'CDOR3M',
    PRIME: 'PRIME',
    TIIE30DAvg: 'TIIE30DAvg',
    CMT3Y: 'CMT3Y',
    CMT5Y: 'CMT5Y',
    CMT7Y: 'CMT7Y',
    CMT10Y: 'CMT10Y',
    SONIA: 'SONIA',
};
//# sourceMappingURL=Bank.js.map